<market-search-card *nonVisitor [isOpen]="isSearchPanelOpen" [localStorageKey]="searchPanelLocalStorageKey" (search)="searchSubject.next($event)"></market-search-card>
<market-products-card [search]="search"></market-products-card>
